import auth from "./auth";
import score from "./score";

const mockAPI = { auth, score };

export default mockAPI;
